import React from "react"
import { Theme } from "@theme"
import { StyleSheet, TouchableOpacity, View } from "react-native"
import { useTheme } from "@react-navigation/native"
import { Text } from "../atoms/text"
import { Icon } from "../atoms"
import { SelectionItem } from "@utils"

export const Hashtag = (props: {name: string, hasBackground?: boolean, onDelete?: (tag: string) => void}) => {
    return(
        <Item {...props} isHashtag/>
    )
}

const Item = ({name, isHashtag = false, hasBackground, onDelete}: {name: string, isHashtag?: boolean, hasBackground?: boolean, onDelete?: (tag: string) => void}) => {
    const theme = useTheme()
    const styles = getStyle(theme)
    const text = isHashtag? `# ${name.replaceAll('#', '')}` : name
    return(
        <TouchableOpacity style={[styles.hashtag, hasBackground && {backgroundColor: theme.colors.primary + '10', borderWidth: 0}]} disabled={!onDelete} onPress={() => onDelete?.(name)}>
            <Text color={theme.colors.primary} type="bodySmall">{text}</Text>
            {!!onDelete && <Icon
                name="cross" 
                color={theme.colors.error} 
                size={15}
                containerStyle={styles.closeIcon}
              />}
        </TouchableOpacity>
    )
}

export const Hashtags = ({hashtags, hasBackground, hasMarginTop, hasMarginBottom, onDelete}: {hashtags: string[], hasBackground?: boolean, hasMarginTop?: boolean, hasMarginBottom?: boolean, onDelete?: (tab: string) => void}) => {
    return (
      <SelectedItems items={hashtags} isRow isHashtag hasBackground={hasBackground} hasMarginTop={hasMarginTop} hasMarginBottom={hasMarginBottom} onDelete={onDelete}/>
    )
}

export const SelectedItems = ({items, isRow = false, isHashtag = false, hasBackground, hasMarginTop, hasMarginBottom, onDelete, renderItem}: {items: string[] | SelectionItem[], isRow?: boolean, isHashtag?: boolean, hasBackground?: boolean, hasMarginTop?: boolean, hasMarginBottom?: boolean, onDelete?: (tag: string) => void, renderItem?: (item: SelectionItem) => React.ReactNode}) => {
    const theme = useTheme()
    const styles = getStyle(theme)
    
    return (
      <View style={[styles.hashtagsContainer, isRow && {flexDirection: 'row'}, hasMarginTop && {marginTop: theme.spacing.md}, hasMarginBottom && {marginBottom: theme.spacing.md}]}>
        {items.map((item, index) =>
        renderItem ? (
            <TouchableOpacity key={index} style={[styles.hashtag, hasBackground && {backgroundColor: theme.colors.primary + '10', borderWidth: 0}]} onPress={() => onDelete?.((item as SelectionItem).id)}>
                {renderItem(item as SelectionItem)}
                {!!onDelete && <Icon
                    name="cross" 
                    color={theme.colors.error} 
                    size={15}
                    containerStyle={styles.closeIcon}
                />}
            </TouchableOpacity>
          ) : (
          <Item key={index} name={item as string} isHashtag={isHashtag} hasBackground={hasBackground} onDelete={onDelete}/>
        ))}
      </View>
    )
}

const getStyle = (theme: Theme) => StyleSheet.create({
    hashtagsContainer: {
        flexWrap: 'wrap',
    },
    hashtag: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginHorizontal: theme.spacing.xs,
        marginBottom: theme.spacing.sm,
        borderWidth: 1,
        borderRadius: theme.border.extraLarge,
        borderColor: theme.colors.primary,
        paddingVertical: theme.spacing.xs,
        paddingHorizontal: theme.spacing.md,
    },
    closeIcon: {
        padding: 3,
        paddingRight: 0,
    },
})